import AddResources from './AddResources';

export default AddResources;
